// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"d0e42bca","534":"1d925f46","787":"b7987608"}[chunkId] + ".chunk.js";
};